module.exports = __webpack_public_path__ + "img/cp47-r2.0400147f.jpg";